// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__258BR","questions":"styles_questions__35iv4","footer":"styles_footer__2lPIz"};